import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: [],
    categories: [],
    loading: false,
    error: null
};

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setMenuItems: (state, action) => {
            state.items = action.payload;
            state.categories = [...new Set(action.payload.map(item => item.category))];
            state.loading = false;
        },
        addMenuItem: (state, action) => {
            state.items.push(action.payload);
            if (!state.categories.includes(action.payload.category)) {
                state.categories.push(action.payload.category);
            }
        },
        updateMenuItem: (state, action) => {
            const index = state.items.findIndex(item => item._id === action.payload._id);
            if (index !== -1) {
                state.items[index] = action.payload;
            }
        },
        deleteMenuItem: (state, action) => {
            state.items = state.items.filter(item => item._id !== action.payload);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const {
    setMenuItems,
    addMenuItem,
    updateMenuItem,
    deleteMenuItem,
    setLoading,
    setError
} = menuSlice.actions;

export default menuSlice.reducer; 